import React from 'react';
import { motion } from 'framer-motion';
import { FileText, Zap, Target, ShieldCheck, CreditCard } from 'lucide-react';
export function Hero() {
  const badges = [{
    icon: <FileText size={16} data-id="element-89" />,
    text: 'PDF descargable'
  }, {
    icon: <Zap size={16} data-id="element-90" />,
    text: 'Acceso inmediato'
  }];
  return <section className="relative pt-3 pb-6 px-3 md:pt-4 md:pb-10 max-w-5xl mx-auto text-center overflow-hidden" data-id="element-91">
      <div className="absolute inset-0 pointer-events-none" style={{
      background: 'radial-gradient(ellipse at center, rgba(168,85,247,0.25) 0%, rgba(168,85,247,0.08) 40%, transparent 70%)'
    }} data-id="element-92" />

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.8
    }} data-id="element-93">
        <span className="inline-block py-0.5 px-2.5 rounded-full bg-accent/10 text-accent font-semibold text-xs mb-2 tracking-wide uppercase" data-id="element-94">
          🔥Salud en tu plato
        </span>

        <h1 className="md:text-5xl lg:text-6xl mb-2 font-[900] font-['Open_Sans',_sans-serif] text-white text-[28px]" data-id="element-95">
          Tu sistema nutricional <span className="text-accent" data-id="element-96">RESUELTO</span>
        </h1>

        <div className="mb-2 flex justify-center" data-id="element-97">
          <img src="https://cdn.magicpatterns.com/uploads/uTVuV5E67j2KLgHLY9Li1x/e937a4a2-0cd5-4f03-8565-db88db61549c.png" alt="Megapack Nutricionista 360º — Nutrición Clínica" className="w-full max-w-[420px] md:max-w-lg drop-shadow-2xl pl-[80px] pr-[80px]" data-id="element-98" />
        </div>

        <p className="md:text-2xl italic text-accent/80 mb-2 max-w-3xl mx-auto text-[15px] font-[800] font-[Avenir,_sans-serif]" data-id="element-99">
          Cómo llenar tu agenda, aumentar honorarios y posicionarte como
          profesional premium
        </p>

        <p className="text-white/60 max-w-2xl mx-auto mb-3 text-[14px]" data-id="element-100">
          El sistema definitivo para nutricionistas clínicos: evaluación +
          soporte nutricional + protocolos por patología + seguimiento +
          criterio clínico avanzado.
        </p>

        <div className="flex flex-wrap justify-center gap-1.5 mb-3 max-w-3xl mx-auto" data-id="element-101">
          {badges.map((badge, idx) => <div key={idx} className="flex items-center gap-1.5 bg-surface border border-accent/10 px-2.5 py-1 rounded-md text-xs text-white/80 font-medium shadow-sm" data-id="element-102">
              <span className="text-accent" data-id="element-103">{badge.icon}</span>
              {badge.text}
            </div>)}
        </div>

        <motion.a href="#comprar" whileHover={{
        scale: 1.02
      }} whileTap={{
        scale: 0.98
      }} className="inline-block bg-accent hover:bg-accent/80 text-black font-bold md:text-lg py-2.5 px-5 md:px-8 rounded-xl shadow-lg shadow-accent/20 transition-colors text-[18px]" data-id="element-104">
          🧠 QUIERO MI MEGAPACK NUTRICIONISTA 360º AHORA
        </motion.a>

        <div className="flex flex-wrap justify-center gap-3 mt-3" data-id="element-105">
          <div className="flex items-center gap-1.5 text-white/50 text-sm font-medium" data-id="element-106">
            <Target size={16} className="text-accent" data-id="element-107" />
            Enfoque clínico
          </div>
          <div className="flex items-center gap-1.5 text-white/50 text-sm font-medium" data-id="element-108">
            <ShieldCheck size={16} className="text-accent" data-id="element-109" />
            Pago seguro
          </div>
          <div className="flex items-center gap-1.5 text-white/50 text-sm font-medium" data-id="element-110">
            <CreditCard size={16} className="text-accent" data-id="element-111" />
            Mercado Pago
          </div>
        </div>
      </motion.div>
    </section>;
}